import { render, staticRenderFns } from "./IconRewardMyReward.vue?vue&type=template&id=0c893b12"
import script from "./IconRewardMyReward.vue?vue&type=script&lang=js"
export * from "./IconRewardMyReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports